import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import * as _moment from 'moment';
import {
  StripeCardElementOptions,
  StripeElementsOptions,
  PaymentIntent,
} from '@stripe/stripe-js';

@Component({
  selector: 'app-plans-payment',
  templateUrl: './plans-payment.component.html',
  styleUrls: ['./plans-payment.component.scss']
})
export class PlansPaymentComponent implements OnInit {

  cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        iconColor: '#666EE8',
        color: '#31325F',
        fontWeight: '300',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: '18px',
        '::placeholder': {
          color: '#CFD7E0',
        },
      },
    },
  };

  elementsOptions: StripeElementsOptions = {
    locale: 'es',
  };

  stripeTest = this.fb.group({
    name: ['Angular v10', [Validators.required]],
    amount: [1001, [Validators.required, Validators.pattern(/\d+/)]],
  });

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
  }

  dialogClose(){
    
  }

  completePayment(){

  }

}
